export default "__VITE_ASSET__B9$uvJQg__"